export default {
  'basicData': {
    'lastName': '八木',
    'firstName': '太郎',
    'lastNameFurigana': '',
    'firstNameFurigana': '',
    'birthYear': '',
    'birthMonth': '',
    'birthDay': '',
    'sex': '',
    'postNumber': '1040040',
    'address1': '東京都中央区築地4',
    'address2': '白山羊ビル3F',
    'addressFurigana': '',
    'tel1': '03',
    'tel2': '1234',
    'tel3': '5678',
    'email': '',
    'idPhotoSrc': '',
    'useContact': '',
    'contactPostNumber': '',
    'contactAddress1': '',
    'contactAddress2': '',
    'contactAddressFurigana': '',
    'contactCareOf': '',
    'contactTel1': '',
    'contactTel2': '',
    'contactTel3': '',
    'contactMobile': '',
    'contactFax': '',
    'contactEmail': '',
    'updateDate': ''
  },
  'formatData': {
    'createDate': new Date(),
    'company_name': '株式会社〇〇〇',
    'staff_name': '人事部　採用ご担当者様',
    'introSummary': '拝啓　新春の候、貴社ますますご繁栄のこととお慶び申し上げます。',
    'entrySummary': 'このたびに掲載されていました飼育員の求人を拝見し、応募させていただきます。\n\n私は4年間、白ヤギ郵便局の郵便物の送達に従事してまいりました。飼育力を強みとする貴社では、これまでの経験を活かしてエサの運び作業に貢献したいと考え、応募させていただきました。\n\nご検討の上、ぜひ面接の機会をいただけると幸いです。\n何卒よろしくお願いいたします。',
    'resumeSummary': '・送付状　1部\n・履歴書 　1部\n・職務経歴書　1部（全3枚）',
    'experienceAndKnowledge': '',
    'skillsToUse': [
      {
        'skillname': '除草',
        'years': '3',
        'description': 'オフの日も個人的に取り組んでいます',
        'uuid': 'd9404372-8982-4324-81a4-f5b4975454d9'
      },
      {
        'skillname': '簿記',
        'years': '5',
        'description': '20xx年x月 3級取得',
        'uuid': '3ba4331c-40bf-4ebc-bc5d-dc7259566fa9'
      }
    ],
    'jobHistories': [
      {
        'companyName': '株式会社◯◯◯◯',
        'startYear': '2016',
        'startMonth': '4',
        'endYear': '',
        'endMonth': '',
        'isContinuing': true,
        'capitalStock': 'xxxx',
        'numberOfEmployees': '30',
        'businessArea': '履歴書サービスの運営スタッフ',
        'projects': [
          {
            'projectTitle': '履歴書サービスの運営スタッフ',
            'startYear': '2018',
            'startMonth': '4',
            'endYear': '2018',
            'endMonth': '8',
            'contentsOfProject': 'ブラウザで履歴書をつくれるWEBサービス『yagish（ヤギッシュ）』の運営スタッフに着任。サイトに訪れたユーザーをお出迎えしたり、渡されたはがきを飼育係に運ぶなど多岐にわたって活躍中。サービスリリース時には、はてなブックマーク800user、GIGAZINE掲載などを果たしました。',
            'envAndScale': '',
            'position': 'メンバー',
            'uuid': '9b6ccada-f15f-496b-86ad-1b80d582fc41'
          }
        ],
        'uuid': '579264f3-1d0c-4dea-97ae-39ee13b93238'
      },
      {
        'companyName': '〇△牧場',
        'startYear': '2013',
        'startMonth': '4',
        'endYear': '2016',
        'endMonth': '4',
        'capitalStock': 'xxxx',
        'numberOfEmployees': '20',
        'businessArea': '自然とふれあう観光・酪農牧場の運営',
        'projects': [
          {
            'projectTitle': '牧草地の除草',
            'startYear': '2013',
            'startMonth': '04',
            'endYear': '2016',
            'endMonth': '04',
            'contentsOfProject': '牧場内の除草に従事。崖などの急傾斜地の草刈りで目標以上の成果をあげて大幅な費用削減を実現しました。',
            'envAndScale': '',
            'position': '',
            'uuid': '61a94659-0813-4994-8a55-3ed81685c1b5'
          },
          {
            'projectTitle': '牧場の警備',
            'startYear': '2013',
            'startMonth': '04',
            'endYear': '2016',
            'endMonth': '04',
            'contentsOfProject': '牧場内の監視。チームのリーダーを担当。野生動物の侵入やごみの不法投棄を0に保ちました。',
            'envAndScale': '',
            'position': '',
            'uuid': 'a56e2c84-9594-4990-987b-21c4c584edd0'
          }
        ],
        'uuid': 'c1eb921c-6263-4321-a922-f4eb86326c59'
      }
    ],
    'licenseHistories': [],
    'prMessage': '前職にて、来場者数の増加を目的とした牧場内の保全に携わりました。長期にわたる除草プロジェクトだったため、自分の成果が実際の来場者数につながっていることが実感でき、非常にやりがいを感じることができました。\nまた、リーダーとしての経験から、チームを率いて成果を最大化させる喜びを知り、より難度の高いプロジェクトに挑戦したいという気持ちが高まりました。\n常にユーザーを意識し、より多くのユーザーに使っていただけるサービスづくりに貢献していきたいと考えております。'
  }
}
